import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { AutoUnsubscribe } from '@app/shared/decorators';
import { RrsDefaultStoreService } from '@app/custom/features/rrs-account/services/rrs-default-store.service';
import { RrsPointOfService } from '@app/custom/features/rrs-storefinder/models/rrs-store-finder.model';
import { RrsStoreFacetService } from '@app/custom/features/rrs-product-listing/services/rrs-store-facet/rrs-store-facet.service';
import { RrsStoreFinderService } from '@app/custom/features/rrs-storefinder/services/rrs-store-finder.service';
import { ModalService } from '@app/custom/features/modal';
import { MyStoreServiceScope } from '@app/custom/features/rrs-product-listing/model/rrs-search-stores.model';

@AutoUnsubscribe()
@Component({
  selector: 'rrs-store-facet',
  templateUrl: './rrs-store-facet.component.html',
  styleUrls: ['./rrs-store-facet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RrsStoreFacetComponent implements OnInit {
  protected subscriptions = new Subscription();
  store$!: Observable<RrsPointOfService | null>;
  isSelected$!: Observable<boolean>;

  constructor(
    protected modalService: ModalService,
    protected storeFacetService: RrsStoreFacetService,
    protected defaultStoreService: RrsDefaultStoreService,
    protected storeFinderService: RrsStoreFinderService
  ) {}

  ngOnInit(): void {
    this.store$ = this.storeFacetService.getSelectedStore('storeFacet');
    this.isSelected$ = this.storeFacetService.isSelected$;
    this.initDefaultStoreSubscription();
  }

  handleFacetClick(): void {
    this.storeFacetService.openSearchStoresDialog(
      MyStoreServiceScope.STORE_FACET
    );
  }

  handleCheckboxClick(e: Event): void {
    this.store$.pipe(take(1)).subscribe((store) => {
      if (store) {
        e.stopPropagation();
        this.storeFacetService.selectFacet();
      }
    });
  }

  private initDefaultStoreSubscription(): void {
    const defaultStoreSub = this.defaultStoreService
      .getDefaultStoreId()
      .pipe(
        filter(
          (storeId) =>
            this.storeFacetService.shouldDisplayDefaultStore && !!storeId
        ),
        tap((storeId) => this.storeFinderService.viewStoreById(storeId!)),
        switchMap(() => this.storeFinderService.getFindStoreById())
      )
      .subscribe((store) => {
        if (store?.name) {
          this.storeFacetService.selectStore(store);
        }
      });
    this.subscriptions.add(defaultStoreSub);
  }
}
